import React from "react";
// import numeral from "numeral";
import moment from "moment";
import { Cache } from "aws-amplify";
import { Link } from "react-router-dom";
import { Table, Icon, Spin, Button, Tooltip } from "antd";

import { parseStatus } from "../../Utils/catalogues";

class OrdersList extends React.Component {
  componentDidMount() {
    Cache.removeItem("limit");
  }
  render() {
    const { loading, error, data, onLoadMore } = this.props;
    if (loading && !data.allOrders) return <Spin />;
    if (error) return <p>Error :(</p>;
    const {
      allOrders: { items: orders = [], nextToken }
    } = data;

    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "orderId",
        render: (text, record) => (
          <Link
            to={`orders/${text}`}
            onClick={() => Cache.setItem("limit", orders.length)}
          >
            {`${text.length > 12 ? "..." : ""}${text.substr(-12)}`}
            {/* {`...${text.split("-")[text.split("-").length - 1]}`} */}
          </Link>
        )
      },

      {
        title: "Servicio",
        dataIndex: "serviceData",
        key: "serviceData",
        width: 320,
        render: text => <span>{text.title}</span>
      },
      {
        title: "Fecha de creación",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 160,
        render: text => moment(text).format("dddd, D MMMM")
      },
      // {
      //   title: "Fecha de Entrega",
      //   dataIndex: "deliveryDate",
      //   key: "deliveryDate",
      //   width: 150,
      //   render: (text, record) =>
      //     moment(record.createdAt)
      //       .add(record.deliveryHours || 72, "hours")
      //       .format("dddd, D MMMM")
      // },
      {
        title: "Estatus",
        key: "status",
        dataIndex: "status",
        // className: "column-center",
        render: text => {
          const { title, description } = parseStatus[text];
          return (
            <span>
              {title}{" "}
              <Tooltip placement="top" title={description}>
                <Icon
                  type="question-circle"
                  style={{ color: "var(--color-yellow-com)" }}
                />
              </Tooltip>
            </span>
          );
        }
      },
      {
        title: "Asignado",
        dataIndex: "partnerAssignedId",
        key: "partnerAssigned",
        render: (text, record) =>
          !(
            record &&
            record.partnerData &&
            record.partnerData.profile &&
            record.partnerData.profile.Attributes &&
            record.partnerData.profile.Attributes.name
          )
            ? "Pendiente"
            : record.partnerData.profile.Attributes.name
      },
      // {
      //   title: "Cantidad",
      //   dataIndex: "amount",
      //   key: "address",
      //   className: "column-center",
      //   render: text => numeral(text).format("$ 0,0.00")
      // },
      // {
      //   title: "Descuento",
      //   key: "discount",
      //   dataIndex: "discount",
      //   className: "column-center",
      //   render: text => numeral(text).format("$ 0,0.00")
      // },
      {
        title: "Pago",
        key: "paid",
        dataIndex: "paid",
        className: "column-center",
        render: text =>
          text ? (
            <Icon style={{ color: "#87d068", fontSize: 20 }} type="check" />
          ) : (
            <span>Pendiente</span>
          )
      },
      {
        title: "Acciones",
        key: "detail",
        fixed: "right",
        width: 120,
        render: (text, record) => (
          <Link
            to={`orders/${record.id}`}
            onClick={() => Cache.setItem("limit", orders.length)}
          >
            Detalle
          </Link>
        )
      }
    ];

    return (
      <React.Fragment>
        <Table
          columns={columns}
          dataSource={orders}
          pagination={false}
          rowKey={record => record.id}
          scroll={{ x: 1300 }}
          style={{ fontFamily: "Montserrat", fontWeight: 100 }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "16px 0"
          }}
        >
          <Button
            onClick={() => onLoadMore(nextToken)}
            disabled={!nextToken}
            loading={loading}
          >
            {nextToken ? "Cargar más..." : "No hay más registros"}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default OrdersList;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrdersList.js